import apiClient from 'ps-components/lib/apiClient';
import { getFormData } from '../../../lib/helpers';

export const MIGRATION_START = 'MIGRATION_START';
export const MIGRATION_SUCCESS = 'MIGRATION_SUCCESS';
export const MIGRATION_ERROR = 'MIGRATION_ERROR';
export const MIGRATION_INIT = 'MIGRATION_INIT';
export const MIGRATION_TIMEOUT = 'MIGRATION_TIMEOUT';
export const MIGRATION_FUNC_START = 'MIGRATION_FUNC_START';
export const MIGRATION_FUNC_SUCCESS = 'MIGRATION_FUNC_SUCCESS';
export const PRESERVE_MATCHES_START = 'PRESERVE_MATCHES_START';
export const PRESERVE_MATCHES_SUCCESS = 'PRESERVE_MATCHES-SUCCESS';
export const SET_PRIORITY_BASED_DATA_CUTS_START = 'SET_PRIORITY_BASED_DATA_CUTS_START';
export const SET_PRIORITY_BASED_DATA_CUTS_SUCCESS = 'SET_PRIORITY_BASED_DATA_CUTS_SUCCESS';

export const TIMEOUT_MESSAGE = 'Failed to migrate, timed out.';

export function setPriorityBasedDataCuts(selectedSurveys, currentSurveyYear, onlyExceptions) {
  return async dispatch => {
    try {
      dispatch({ type: MIGRATION_START });
      dispatch({ type: SET_PRIORITY_BASED_DATA_CUTS_START });
      const results = await Promise.all(
        selectedSurveys.map(el => {
          return apiClient.apiPost('/api/migration/data-cuts/setPriorityMatchDataCuts', {
            currentSurveyCode: el.curSurveyCode,
            newSurveyCode: el.newSurveyCode,
            currentSurveyYear: currentSurveyYear.toString(),
            onlyExceptions: onlyExceptions
          });
        })
      );

      dispatch({ type: SET_PRIORITY_BASED_DATA_CUTS_SUCCESS, payload: results });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
}

export function runMigration(selectedSurveys, curSurveyYear, newSurveyYear, preserveMatches) {
  return async dispatch => {
    try {
      dispatch({ type: MIGRATION_FUNC_START });
      const surveyList = selectedSurveys.map(record => [record.curSurveyCode, record.newSurveyCode]);
      // API Call to start new migration and get total jobs to be migrated
      const newMigration = await apiClient.apiPost('/api/migration/selected-surveys/newMigration', {
        curSurveyYear: curSurveyYear,
        newSurveyYear: newSurveyYear,
        surveyList: surveyList
      });
      // API Call to perform the migration, makes a call to mark the migration as complete in redis
      await apiClient.apiPost(
        '/migration/set-matches-perm',
        getFormData({
          survey_list: surveyList,
          current_survey_year: curSurveyYear,
          new_survey_year: newSurveyYear,
          preserve_matches: preserveMatches,
          migrationId: newMigration.data.result.id
        }),
        {
          useMerit: true
        }
      );

      try {
        await performMigrationLoop(newMigration);
      } catch (migrationCheck) {
        clearInterval(migrationCheck);
        throw new Error(TIMEOUT_MESSAGE);
      }

      // API call to update migration session rows for in-year migrations since there could be new rows
      if (curSurveyYear === newSurveyYear) {
        await apiClient.apiPost(
          '/migration/migrate',
          getFormData({
            current_survey_year: curSurveyYear,
            new_survey_year: newSurveyYear
          }),
          {
            useMerit: true
          }
        );
      }

      dispatch({ type: MIGRATION_FUNC_SUCCESS });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
}

async function performMigrationLoop(newMigration) {
  // Promise loop to run until timeout or until migration is complete
  let migrateCheck = await checkMigration(newMigration.data.result.id);
  // Used for timeout, may need to change timeout functionality in the future
  let iterationCount = 1;
  if (migrateCheck.success) {
    return;
  } else {
    const migrationCheck = setInterval(async () => {
      migrateCheck = await checkMigration(newMigration.data.result.id);
      if (migrateCheck.success) {
        clearInterval(migrationCheck);
        return;
      }
      iterationCount++;
      // If 25 minutes have passed, error out
      if (iterationCount === 300) throw migrationCheck;
    }, 5000);
  }
}

/*
Performs a looped check every 5 seconds to see
if the migraiton is complete
(sees if handled exceptions and easy migrations are done)
*/
async function checkMigration(migrationId) {
  let data = await apiClient.apiPost('/api/migration/selected-surveys/checkMigration', {
    migrationId: migrationId
  });
  if (data.data.result && data.data.result.migrationDone) {
    return { success: true };
  } else {
    return { success: false };
  }
}

export function preserveMatches(currentWeight, currentSurveyYear, newSurveyYear, selectedSurveys) {
  return async dispatch => {
    try {
      const surveyList = selectedSurveys.map(record => [record.curSurveyCode, record.newSurveyCode]);
      dispatch({ type: PRESERVE_MATCHES_START });
      await apiClient
        .apiPost(
          '/migration/migrate-matches-exceptions',
          getFormData({
            current_survey_year: currentSurveyYear,
            new_survey_year: newSurveyYear,
            rb_copy_existing: currentWeight ? 1 : 2,
            survey_list: surveyList
          }),
          {
            useMerit: true
          }
        )
        .then(() => {
          // Nothing is done with the results until the preserve/zero-weight is implemented
          dispatch({ type: PRESERVE_MATCHES_SUCCESS });
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
}

export const endMigrationProcessSuccess = e => {
  return {
    type: MIGRATION_SUCCESS
  };
};

export const endMigrationProcessError = e => {
  return {
    type: MIGRATION_ERROR
  };
};

export const endMigrationTimeout = () => {
  return {
    type: MIGRATION_TIMEOUT
  };
};

export const resetMigrationProcess = e => {
  return {
    type: MIGRATION_INIT
  };
};
